import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';

const state = () => ({
  me: null,
  loading: false,
  documents: [],
  stats: null,
});

export default {
  mutations,
  actions,
  getters,
  state,
};
